import FirebaseConfig from "../firebaseConfig";

const db = FirebaseConfig.firestore(),
    assignRef = db.collection('mentors');
const dbb = FirebaseConfig.firestore(),
    menteeRef = dbb.collection('mentee');


// assign mnetor to mentee collection
export async function assignMentor(data) {
        for (let i=0; i<data.selectedMentee.length; i++){
            let docid = menteeRef.doc(data.selectedMentee[i])
            if (docid){
                docid.update({
                    "assigned_mentor":  data.selectedMentor
                })
            }
        }
}

//  remove mentor from mentee collection
export async function removeMentor(data, mentor){
    let docid = menteeRef.doc(data)
    let mentordoc = assignRef.doc(mentor)
    if (mentordoc) {
        mentordoc.update({
            "assigned_mentee": FirebaseConfig.firestore.FieldValue.arrayRemove(data)
        })
    }
    if (docid){
        docid.update({
            "assigned_mentor": ""
        })
    }
    
}
 
// assign mentee to mentor collection
export async function assignMentee(data) {
    let mentordoc = assignRef.doc(data.selectedMentor)
    if (mentordoc){
            mentordoc.update({
                "assigned_mentee": data.selectedMentee
            })
        
    }
    else{
            // console.log("Failed");
        }
    }

export async function getAssignedMentee(data, callback) {
    let mentordoc = assignRef.doc(data)
    mentordoc.get().then((doc)=>{
        if(doc.exists){
            callback(doc.data(), true);
        }
    }).catch((error)=> {callback({}, false)});
}

